export default "__VITE_ASSET__crwRN4Yq__"